/*
 *    Copyright (c) 2018-2025, insuranceagent All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * Redistributions of source code must retain the above copyright notice,
 * this list of conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright
 * notice, this list of conditions and the following disclaimer in the
 * documentation and/or other materials provided with the distribution.
 * Neither the name of the pig4cloud.com developer nor the names of its
 * contributors may be used to endorse or promote products derived from
 * this software without specific prior written permission.
 * Author: insuranceagent
 */

import request from '@/router/axios'
import qs from 'qs'
import {dealClearCode} from 'meibao-insure/src/util/commonUtils'
import store from '@/store'
import {centerObjectGet, centerObjectPost} from 'meibao-insure/src/api/productCenterNew'

/*
 *  保单相关接口
 */

//  获取包括子渠道的全部保单列表
export function fetchPolicyList(query) {
	return request({
		url: '/dist/distOrder/list',
		method: 'get',
		params: query,
	})
}

//  获取当前账户产生的保单列表
export function fetchMyPolicyList(query) {
	return request({
		url: '/dist/distOrder/myList',
		method: 'get',
		params: query,
	})
}

//  获取保单详情
export function getPolicyDetails(id) {
	return request({
		url: '/dist/distOrder/detail/' + id,
		method: 'get',
	})
}

//  获取指定保单的投保人员列表
export function fetchEmployeeList(query) {
	return request({
		url: '/dist/distOrder/empList',
		method: 'get',
		params: query,
	})
}

//  获取指定保单的投保人员列表
export function fetchEmployeeListPage(query) {
	return request({
		url: '/dist/distOrder/empPage',
		method: 'get',
		params: query,
	})
}

//  获取指定保单的批增、批改记录
export function fetchRecordList(query) {
	return request({
		url: '/dist/distOrder/recordList',
		method: 'get',
		params: query,
	})
}

//  获取指定批增或批改记录详情
export function getRecordDetails(id) {
	return request({
		url: '/dist/distOrder/detail/' + id,
		method: 'get',
	})
}

//  获取批增或批改人员信息
export function getEndorsementDetails(id) {
	return request({
		url: '/dist/distOrder/recordEmpList/' + id,
		method: 'get',
	})
}

//  处理中保单
export function proxyProcess(obj) {
	return request({
		url: '/dist/distOrder/proxyProcess',
		method: 'post',
		data: obj,
	})
}

export function proxyProcessMy(obj) {
	return request({
		url: '/dist/distOrder/proxyProcessMy',
		method: 'post',
		data: obj,
	})
}

export function exportDownload(type, orderId) {
	return request({
		url: '/dist/distOrder/exportDownload/' + type + '/' + orderId,
		method: 'get',
		responseType: 'blob',
	})
}

/*
 *  产品相关接口
 */

//  获取指定产品的职业分类
export function getProfessionCategory(id, orderId) {
	return request({
		url: '/dist/distProduct/category/current/' + id,
		method: 'get',
		params: {
			orderId,
		},
	})
}

//  获取指定产品的三级职业分类树
export function getProfessionTree(id) {
	return request({
		url: '/dist/distProduct/category/tree/' + id,
		method: 'get',
	})
}

export function getProfessionTreeWithQuery(id, query = {}) {
	return request({
		url: '/dist/distProduct/category/tree/' + id,
		method: 'get',
		params: query,
	})
}

/*
 *  投保相关接口
 */

//  查找上次未完成保单的暂存填写数据
export function stagingFind(query) {
	return request({
		url: '/dist/distInsure/findStaging',
		method: 'get',
		params: query,
	})
}

//  更新当前填写保单暂存数据
export function stagingRefresh(id, obj) {
	return request({
		url: '/dist/distInsure/refreshStaging/' + id,
		method: 'post',
		headers: {'content-type': 'application/x-www-form-urlencoded'},
		data: qs.stringify(obj),
	})
}

//  查询历史投保网点
export function getUnitHistory(query) {
	return request({
		url: '/dist/distInsure/unitHistory',
		method: 'get',
		params: query,
	})
}

//  上传文件
export function uploadFile(obj) {
	return request({
		url: '/dist/distInsure/uploadFile',
		method: 'post',
		data: obj,
	})
}

//  校验投被保企业
export function checkUnit(query) {
	///v2/insure/verify_holder
	// return request({
	//   url: '/dist/distInsure/checkUnit',
	//   method: 'get',
	//   params: query,
	// })
	return centerObjectPost('v2/insure/verify_holder', query)
}

//  校验保单生效日期
export function checkEffectiveDate(query) {
	return request({
		url: '/dist/distInsure/checkEffectiveDate',
		method: 'get',
		params: query,
	})
}

//  计算保费
export function calcPremium(obj) {
	return request({
		url: '/dist/distInsure/calcPremium',
		method: 'post',
		data: obj,
	})
}

//  校验投保信息
export function checkInsure(obj) {
	return request({
		url: '/dist/distInsure/checkInsure',
		method: 'post',
		headers: {'content-type': 'application/x-www-form-urlencoded'},
		data: qs.stringify(obj),
	})
}

//  提交保单
export function insure(obj, insureType) {
	//获取是否需要清除code
	let headers = dealClearCode(insureType, store)
	headers['content-type'] = 'application/x-www-form-urlencoded'
	return request({
		url: '/dist/distInsure/insure',
		method: 'post',
		headers,
		data: qs.stringify(obj),
	})
}

//  查询保单是否可以批增或批改
export function checkEndorse(query) {
	return request({
		url: '/dist/distInsure/checkEndorse',
		method: 'get',
		params: query,
	})
}

//  取消批单
export function cancelEndorse(id) {
	return request({
		url: '/dist/distInsure/cancelEndorse/' + id,
		method: 'put',
	})
}

//  批增
export function endorseAdd(obj, insureType) {
	//获取是否需要清除code
	let headers = dealClearCode(insureType, store)
	headers['content-type'] = 'application/x-www-form-urlencoded'
	return request({
		url: '/dist/distInsure/addEmployee',
		method: 'post',
		headers,
		data: qs.stringify(obj),
	})
}

//  获取开票信息（批增）
export function getInvoiceInfo(query) {
	return request({
		url: '/dist/distInsure/invoiceInfo',
		method: 'get',
		params: query,
	})
}

//  支付保费
export function pay(id, payMethod = '', insureType) {
	//获取是否需要清除code
	let headers = dealClearCode(insureType, store)
	return request({
		url: `/dist/distInsure/pay/${id}${payMethod ? `?payType=${payMethod}` : ''}`,
		method: 'get',
		headers,
	})
}

//  查询支付结果
export function getPayStatus(id) {
	return request({
		url: '/dist/distInsure/payStatus/' + id,
		method: 'get',
	})
}

//  批改
export function endorseReplace(obj, insureType) {
	let headers = dealClearCode(insureType, store)
	return request({
		url: '/dist/distInsure/batchModify',
		method: 'post',
		// headers: { 'content-type': 'application/x-www-form-urlencoded' },
		// data: qs.stringify(obj)
		headers,
		data: obj,
	})
}

//  批改起始生效日期
export function getReplaceEffectiveDate(query) {
	return request({
		url: '/dist/distInsure/getEffectiveDate',
		method: 'get',
		params: query,
	})
}

//  查询批单状态
export function getReplaceResult(id) {
	return request({
		url: '/dist/distInsure/queryBatch/' + id,
		method: 'get',
	})
}

//  查询批增状态
export function getEndorseStatus(id) {
	return request({
		url: '/dist/distInsure/queryEndorse/' + id,
		method: 'get',
	})
}

//  查询重新提交表单所属数据
export function getResubmitPolicy(id) {
	return request({
		url: '/dist/distInsure/getResubmitData/' + id,
		method: 'get',
	})
}

//  续保数据
export function getRenewPolicy(id) {
	return request({
		url: '/dist/distInsure/getRenewData/' + id,
		method: 'get',
	})
}

//  非同一网点重复投保人员
export function getRepeatEmpList(obj) {
	return request({
		url: '/dist/distInsure/repeatEmpList',
		method: 'post',
		headers: {'content-type': 'application/x-www-form-urlencoded'},
		data: qs.stringify(obj),
	})
}

//  上传支付凭证
export function payOffline(query, obj) {
	return request({
		url: '/dist/distInsure/uploadPayCertFile',
		method: 'post',
		headers: {'content-type': 'multipart/form-data'},
		params: query,
		data: obj,
	})
}

export function canPayOffline(query, insureType) {
	let headers = dealClearCode(insureType, store)
	return request({
		url: '/dist/distInsure/checkAllowOffPay',
		method: 'get',
		params: query,
		headers,
	})
}

export function getDocs(query) {
	return request({
		url: '/dist/distInsure/getDocs',
		method: 'get',
		params: query,
	})
}

/*
 *  保单暂存功能接口
 */
export function getStagingList() {
	return request({
		url: '/dist/distOrder/staging/list',
		method: 'get',
	})
}

export function addStaging(obj) {
	return request({
		url: '/dist/distOrder/staging/add',
		method: 'post',
		data: obj,
	})
}

export function delStaging(id) {
	return request({
		url: '/dist/distOrder/staging/del/' + id,
		method: 'delete',
	})
}

export function getStagingDetail(id) {
	return request({
		url: '/dist/distOrder/staging/detail/' + id,
		method: 'get',
	})
}

/*
 *  辅助功能接口
 */

//  获取区域列表
export function getAreaList(level) {
	return request({
		url: '/dist/area/list/' + level,
		method: 'get',
	})
}

//模板下载接口
export function getPolicyEmpTemp(orderId) {
	return request({
		url: `/dist/distInsure/categoryDownload/${orderId}`,
		method: 'get',
		responseType: 'blob',
	})
}

//批量更改被保险人，和批量替换按钮显示
export function getInsuredCheckSpecDate() {
	return request({
		url: '/dist/distInsure/checkSpecDate',
		method: 'get',
	})
}

//批量更改被保险人，和批量替换按钮显示
export function getChannelMainInfo() {
	return request({
		url: '/dist/distChannel/main',
		method: 'get',
	})
}

//校验是否可以续保和重新提交
export function redoOrder(orderId) {
	return request({
		url: `/dist/distInsure/redoOrder/${orderId}`,
		method: 'get',
	})
}

//校验是否可以续保
export function renewOrder(orderId) {
	return request({
		url: `/dist/distInsure/renewOrder/${orderId}`,
		method: 'get',
	})
}

//通过营业执照获取企业信息  /agent/employer/insure/calc_premium
export function getUnitInfoByLicense(url, pid = '') {
	return request({
		// url: `/agent/employer/service/parse_license`,
		url: `/dist/distInsure/parseLicense`,
		method: 'post',
		data: {
			url,
			pid,
		},
	})
}

// 校验身份证信息
export function checkIdNo(data) {
	return request({
		url: '/dist/distInsure/checkIdno',
		method: 'post',
		data,
	})
}

//校验身份证图片
export function uploadIdNoImg(data) {
	return request({
		url: '/dist/distInsure/uploadIdOcr',
		method: 'post',
		headers: {'content-type': 'multipart/form-data'},
		data,
	})
}

//通过新的souceProductId 获取 产品中心Id 1=投保；2=批增；3=替换
export function getCenterProductId(sourceProductId, operate = 1) {
	let tempReq = {
		sourceProductIds: [sourceProductId],
		operate,
	}
	return new Promise((resolve, reject) => {
		centerObjectPost(`/v2/product/mapping`, tempReq)
			.then((res) => {
				let {code = -1, data = []} = res.data
				if (code === 0 && data.length > 0) {
					let {productId = ''} = data[0]
					resolve(productId !== '' ? data[0] : {})
				} else {
					resolve()
				}
			})
			.catch(() => {
				reject()
			})
	})
}

// 续保：/service/renew/batch/data/{payId}
// 重新提交:/service/resubmit/batch/data/{payId}
// payId在保单列表、保单详情接口都有返回

export function getResubmitData(payId) {
	return centerObjectGet(`/service/resubmit/batch/data/${payId}`)
}

export function getRenewData(payId) {
	return centerObjectGet(`/service/renew/batch/data/${payId}`)
}
